/* eslint-disable @typescript-eslint/no-magic-numbers */

enum AkamaiImageManagerGravity {
  North = 'North', // Anchors the crop at the top center of the image.
  South = 'South', // Anchors the crop at the bottom center of the image.
  East = 'East', // Anchors the crop at the right center of the image.
  West = 'West', // Anchors the crop at the left center of the image.
  NorthWest = 'NorthWest', // Anchors the crop at the top left corner of the image.
  NorthEast = 'NorthEast', // Anchors the crop at the top right corner of the image.
  SouthWest = 'SouthWest', // Anchors the crop at the bottom left corner of the image.
  SouthEast = 'SouthEast', // Anchors the crop at the bottom right corner of the image.
  Center = 'Center' // Anchors the crop at the center of the image (default).
}

interface CroppingData {
  cropping: [number, number, number, number];
  gravity: AkamaiImageManagerGravity;
  width: number;
}

type CroppingDataById = Record<
  string,
  {
    [maxWidth: string]: CroppingData;
    default: CroppingData;
  }
>;

export const stageBackgroundCroppingData: CroppingDataById = {
  MUSEUM: {
    default: {
      cropping: [-200, -80, 3500, 900],
      gravity: AkamaiImageManagerGravity.Center,
      width: 2048
    },
    '480': {
      cropping: [0, -100, 3000, 1200],
      gravity: AkamaiImageManagerGravity.Center,
      width: 640
    },
    '768': {
      cropping: [0, -100, 3000, 1200],
      gravity: AkamaiImageManagerGravity.Center,
      width: 1024
    },
    '1024': {
      cropping: [0, -80, 2000, 1200],
      gravity: AkamaiImageManagerGravity.Center,
      width: 1400
    },
    '1280': {
      cropping: [-50, -100, 3500, 900],
      gravity: AkamaiImageManagerGravity.Center,
      width: 1400
    },
    '1440': {
      cropping: [-250, -100, 3500, 850],
      gravity: AkamaiImageManagerGravity.Center,
      width: 2048
    },
    '1920': {
      cropping: [-200, -80, 3500, 900],
      gravity: AkamaiImageManagerGravity.Center,
      width: 2048
    }
  },
  WINTER: {
    default: {
      cropping: [0, -500, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 2048
    },
    '480': {
      cropping: [0, -1000, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 640
    },
    '768': {
      cropping: [0, -500, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 1024
    },
    '1024': {
      cropping: [0, -500, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 1400
    },
    '1280': {
      cropping: [0, -500, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 1400
    },
    '1440': {
      cropping: [0, -500, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 2048
    },
    '1920': {
      cropping: [0, -500, 0, 0],
      gravity: AkamaiImageManagerGravity.North,
      width: 2048
    }
  }
};
